// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-header[data-v-29184460]{border:none}.main[data-v-29184460]{background:#f0f3f5!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
